import { useRecoilValue } from 'recoil';

import {
  MYRIAD_STAFF_LABEL,
  getCreatorAvatarProps,
  getCreatorDisplayName
} from 'components/shared/ExpandableToolbar/lib/helpers';
import state from 'components/state';

export const useActivityCreator = (activity) => {
  const userState = useRecoilValue(state.userState);
  const permission = useRecoilValue(state.permissions);

  const { creator, created_by_type } = activity;

  const currentUserId = permission?.admin_id || userState?.id;

  const isViewerAdmin = !!permission?.admin_id;

  const isCurrentUser = currentUserId && creator?.id === currentUserId;
  const fullName = getCreatorDisplayName({
    creator,
    isAdminAction: created_by_type === 0,
    isViewerAdmin
  });
  const displayName = isCurrentUser ? 'You' : fullName;
  const avatarProps = getCreatorAvatarProps({
    creator,
    isMasked: fullName === MYRIAD_STAFF_LABEL && !isCurrentUser
  });

  return { displayName, fullName, avatarProps };
};
